import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

const RichText = ({ content, as: Component = 'div', className = '', ...props }) => {
  const sanitized = useMemo(() => (content ? DOMPurify.sanitize(content) : ''), [content]);

  if (!sanitized) {
    return null;
  }

  return (
    <Component
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitized }}
      {...props}
    />
  );
};

export default RichText;
